/**
 * Application route constants
 * Centralized route definitions to prevent typos and make refactoring safer
 */
export const ROUTES = {
  // Main navigation
  root: '/',
  projects: '/',
  renderings: '/renderings',

  // Assets
  assets: '/assets',
  videos: '/videos',
  images: '/images',
  imageUploads: '/images/uploads',
  imageStock: '/images/stock',
  uploads: '/uploads',
  stock: '/stock',
  importRoot: '/assets/import',
  stockSearch: '/assets/import/stock',
  exportsRoot: '/exports',
  exportsFor: (projectId: string) => `/exports/${projectId}`,
  audios: '/audios',
  
  // Settings & Config
  chats: '/chats',
  chatSetup: (service: 'chatgpt' | 'claude' | 'cursor') => `/chats/${service}`,
  integrations: '/integrations',
  settings: '/settings',
  plans: '/plans',
  // Preview (standalone player with black background)
  preview: (projectId?: string) => (projectId ? `/preview/${projectId}` : '/preview'),
  
  // Player (in-app player with back navigation)
  player: (id: string) => `/player/${id}`,
  playerStockPreview: '/player/stock-preview' as const,

  // Editor
  editor: (id: string) => `/editor/${id}`,

  // Player V2 (optimized version for testing)
  playerV2: (id: string) => `/player-v2/${id}`,
  previewV2: (projectId?: string) => (projectId ? `/preview-v2/${projectId}` : '/preview-v2'),
  playerV2StockPreview: '/player-v2/stock-preview' as const,

  // Import aliases
  import: '/import' as const,
  importStock: '/import-stock' as const,
} as const


